// extracted by mini-css-extract-plugin
export default {"broadcasts":"BroadcastsMobile_broadcasts__JGM0k"};